// Конвертує обмежений набір HTML-тегів, які повертає AI-аналіз (h2, h3, p, ul, ol, li, strong),
// у текстовий markdown — щоб результат аналізу можна було скопіювати і вставити будь-куди як звичайний текст.
export function htmlToMarkdown(html: string): string {
  const container = document.createElement('div');
  container.innerHTML = html;

  const inlineText = (node: ChildNode): string => {
    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent ?? '';
    }
    if (node.nodeType !== Node.ELEMENT_NODE) {
      return '';
    }
    const el = node as HTMLElement;
    const inner = Array.from(el.childNodes).map(inlineText).join('');
    switch (el.tagName) {
      case 'STRONG':
      case 'B':
        return `**${inner}**`;
      case 'EM':
      case 'I':
        return `*${inner}*`;
      case 'BR':
        return '\n';
      default:
        return inner;
    }
  };

  const lines: string[] = [];

  container.childNodes.forEach((node) => {
    if (node.nodeType !== Node.ELEMENT_NODE) {
      const text = node.textContent?.trim();
      if (text) lines.push(text, '');
      return;
    }
    const el = node as HTMLElement;
    switch (el.tagName) {
      case 'H2':
        lines.push(`## ${inlineText(el).trim()}`, '');
        break;
      case 'H3':
        lines.push(`### ${inlineText(el).trim()}`, '');
        break;
      case 'P':
        lines.push(inlineText(el).trim(), '');
        break;
      case 'UL':
        Array.from(el.children).forEach((li) => {
          lines.push(`- ${inlineText(li as HTMLElement).trim()}`);
        });
        lines.push('');
        break;
      case 'OL':
        Array.from(el.children).forEach((li, i) => {
          lines.push(`${i + 1}. ${inlineText(li as HTMLElement).trim()}`);
        });
        lines.push('');
        break;
      default: {
        const text = inlineText(el).trim();
        if (text) lines.push(text, '');
      }
    }
  });

  return lines.join('\n').replace(/\n{3,}/g, '\n\n').trim();
}
